import React, { useState } from 'react';
import { Helmet } from 'react-helmet';  // Importera Helmet

function Kontakt() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Hantera ändringar i formuläret
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Skicka formuläret
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Skicka formuläret till PHP (ändra URL om du har en annan serveradress)
    const response = await fetch('http://localhost/backend/kontakt-send-mail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // Skicka som form-data
      },
      body: new URLSearchParams(formData), // Använd URLSearchParams för att konvertera formData till form-data format
    });

    if (response.ok) {
      setIsSubmitted(true); // Visar tack-meddelande om det gick bra
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
      }); // Tömmer formuläret
    } else {
      // Om något går fel, kan vi hantera det här
      alert('Något gick fel, försök igen senare.');
    }
  };

  return (
    <>
    <Helmet>
            <title>Kontakta Provalt Service AB – Vi Hjälper Dig Gärna</title>
            <meta name="description" content="Har du frågor eller vill boka en tjänst? Kontakta Provalt Service AB via telefon, e-post eller kontaktformulär. Snabb och personlig service!" />
          <link rel="canonical" href="https://provalt.se/kontakt" />
          </Helmet>
    <section className="p-8 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold mb-4 text-center">Kontakta oss</h2>

      <div className="mb-8 space-y-4 text-gray-800">
        <p>
          Har du frågor om våra tjänster, vill boka en städning eller behöver en skräddarsydd lösning? 
          Vi finns här för att hjälpa dig! Vårt team av städexperter står redo att svara på dina funderingar 
          och hitta den bästa lösningen för dina behov.
        </p>
        <p>
          Tveka inte att höra av dig – vi strävar efter att göra det enkelt för dig att skapa en ren och trivsam miljö, 
          oavsett om det gäller hem, kontor eller större lokaler.
        </p>
        <p>
          Kontakta oss idag via telefon, e-post eller vårt kontaktformulär, så återkommer vi till dig så snart som möjligt!
        </p>

        <div className="bg-gray-100 p-4 rounded">
          <h3 className="font-semibold mb-2">Öppettider</h3>
          <p>Måndag – fredag: 07:30 – 17:00</p>
          <p>Lördag: 10:00 – 15:00</p>
          <p>Söndag: Stängd</p>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h3 className="font-semibold mb-2">Företagsinformation</h3>
          <p>Adress: Västberga Allé 32, 126 30 Hägersten</p>
          <p>Org-nr: 559414-1565</p>
        </div>
      </div>

      {/* Visar tack-meddelande när formuläret skickas */}
      {isSubmitted ? (
        <div className="text-center text-green-600 mb-4">
          <p>Tack för ditt meddelande! Vi återkommer till dig så snart som möjligt.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4 max-w-xl mx-auto">
          <input
            type="text"
            name="name"
            placeholder="Namn"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="E-post"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="Ämne"
            value={formData.subject}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
          />
          <textarea
            name="message"
            placeholder="Meddelande..."
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border rounded h-32"
            required
          />
          
          {/* Centrera knappen */}
          <div className="flex justify-center">
            <button type="submit" className="px-4 py-2 bg-green-700 text-white rounded">
              Skicka
            </button>
          </div>
        </form>
      )}
    </section>
    </>
  );
}

export default Kontakt;
